import React from "react";
import CourseView from "./CourseView";
import axios from "axios";

import * as Globals from "./../Globals";

export default class CourseOverview extends React.Component {
  constructor(props) {
    super(props);

    this.viewID = -1;
    this.courses = undefined;
    this.userID = this.props.userID;

    this.state = {
      key: 0,
      testresults: undefined,
      searchFiler: ""
    };
  }

  componentDidMount() {
    let cookie = this.props.LogoutOnCookieNotSet();
    axios
      .get(Globals.BASE_PATH + "api/courses", {
        headers: {
          Accept: "application/json",
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          Authorization: "Bearer " + cookie
        }
      })
      .then(response => {
        this.courses = response.data.data;
        this.setState({
          key: Math.random()
        });
      })
      .catch(error => {
        this.props.CheckAuthError(error);
      });
    this.initSimulationResults();
  }
  initSimulationResults() {
    let cookie = this.props.LogoutOnCookieNotSet();
    axios
      .get(Globals.EL_PATH + "user/" + this.userID + "/testsimulation?Authentication=" + cookie, {
        headers: {
          Accept: "application/json",
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          Authorization: "Bearer " + cookie
        }
      })
      .then(response => {
        this.setState({ testresults: response.data.records });
      })
      .catch(error => {
        if (error.response.status === 404) {
          this.setState({ testresults: undefined });
        }
        this.props.CheckAuthError(error);
      });
  }

  reloadCourses() {
    this.componentDidMount();
  }

  changeViewID(id) {
    this.viewID = id;
    this.forceUpdate();
  }

  closeCourseView() {
    this.viewID = -1;
    this.reloadCourses();
  }
  getSimulationResults() {
    if (this.state.testresults !== undefined) {
      return (
        <div className="container" >
          <h3 className="text-center" style={{ marginTop: "40px", marginBottom: "20px" }}>
            Simulationsergebnisse
          </h3>
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>Fächer</th>
                <th>Erreichte Prozent</th>
              </tr>
            </thead>
            <tbody>
              {this.state.testresults.map((result, index) => {
                return (
                  <tr key={index}>
                    <td>{result.name}</td>
                    <td>{result.percentage}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      );
    }
  }

  handleSearchFilterChange(event) {
    this.setState({
      searchFiler: event.target.value
    });
  }

  renderCourseOverview() {
    if (this.courses === undefined) {
      return (
        <ul className="list-group">
          <li className="list-group-item">
            <p className="text-center" style={{ margin: 0 }}>
              <b>Kurse werden geladen.</b>
            </p>
          </li>
        </ul>
      );
    } else if (this.courses.length === 0) {
      return (
        <ul className="list-group">
          <li className="list-group-item">
            <p className="text-center" style={{ margin: 0 }}>
              <b>Sie nehmen an keinem Kurs teil.</b>
            </p>
          </li>
        </ul>
      );
    } else {
      return (
        <div>
          <ul className="list-group">
            {this.courses.map((course, index) => {
              if (course.id.toString().indexOf(this.state.searchFiler) !== -1) {
                return (
                  <li key={index} className="list-group-item text-center" onClick={() => this.changeViewID(course.id)}>
                    {course["course-topic"].name}

                  </li>
                );
              }
              return null;
            })}
          </ul>
        </div>
      );
    }
  }

  getRenderBlock() {
    if (this.viewID < 0) {
      return (
        <div>
          <div className="container greeting">
            <h2 className="text-center">
              Herzlich Willkommen, {this.props.sex === "male" ? "Herr" : "Frau"}{" "}
              {this.props.firstname} {this.props.lastname}!
            </h2>
            <h4 className="text-center">Sie sind eingeloggt als Teilnehmer.</h4>
          </div>
          <div className="courses">
            <h1 >Kursübersicht</h1>
            {this.renderCourseOverview()}
          </div>
          {this.getSimulationResults()}
        </div>
      );
    } else {
      return (
        <div>
          <CourseView
            CheckAuthError={this.props.CheckAuthError}
            LogoutOnCookieNotSet={this.props.LogoutOnCookieNotSet}
            userID={this.userID}
            id={this.viewID}
            closeCourseView={this.closeCourseView.bind(this)}
          />
        </div>
      );
    }
  }
  render() {
    return this.getRenderBlock();
  }
}



// WEBPACK FOOTER //
// ./src/user/CourseOverview.js